/* eslint-disable no-unused-vars */
import {
  Grid,
  InputLabel,
  Autocomplete,
  TextField,
  FormHelperText,
  Box,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";

const AutoComplete = (props) => {
  const { label, name, formik, required, options, noOptionsLoader, ...rest } =
    props;
  const [dropdownOptions, setDropdownOptions] = useState(options);
  const [emptyMsg, setEmptyMsg] = useState(
    <Box sx={{ display: "flex" }}>
      <CircularProgress size={20} />
    </Box>,
  );

  // const findAllOptionsSelectedVerbal = (value) => {
  //   switch (value.key) {
  //   case 'Όλες':
  //     return value.appointment
  //       ? labels.DropDowns.selectedAllStatus
  //       : labels.DropDowns.selectedAllCases;
  //   case 'Όλοι':
  //     return labels.DropDowns.selectedAllTypes;
  //   default:
  //     return labels.DropDowns.selectedAllOffices;
  //   }
  // };

  const handleChange = (value) => {
    formik.setFieldValue(
      name,
      value.map((value) => value.value),
    );
  };

  return (
    <Grid>
      <Box
        sx={{
          borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
          paddingLeft: formik.errors[name] ? "16px" : "",
        }}
      >
        <InputLabel
          sx={{
            marginBottom: "15px",
            fontWeight: required ? "bold" : "500",
          }}
        >
          {label}
        </InputLabel>
        <Autocomplete
          sx={{ minWidth: 200, maxWidth: 300 }}
          filterSelectedOptions
          noOptionsText={emptyMsg}
          multiple
          options={dropdownOptions.length > 0 ? dropdownOptions : options}
          getOptionLabel={(option) => {
            return option.key || "all";
          }}
          isOptionEqualToValue={(option, value) => value.key === option.key}
          onChange={(_, value) => handleChange(value)}
          {...rest}
          renderInput={(params) => <TextField {...params} id={name} />}
        />
        {!!formik.errors[name] && (
          <FormHelperText
            sx={{
              fontWeight: "bolder",
            }}
            error
          >
            {formik.errors[name]}
          </FormHelperText>
        )}
      </Box>
    </Grid>
  );
};

export default AutoComplete;
